import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLearningModule } from "./learningAPI";

export interface LearningMState {
  learningmodule: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: LearningMState = {
  learningmodule: [],
  status: "idle",
};

export const GetLearningModule = createAsyncThunk(
  "learning/fetchLearning",
  async (data:any) => {
    const response = await fetchLearningModule(data);
    return response;
  }
);

export const learningModuleSlice = createSlice({
  name: "learing",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLearningModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLearningModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetLearningModule.fulfilled, (state, action) => {
        state.status = "idle";
       // state.learningmodule =state.learningmodule.concat( action.payload.material);
       state.learningmodule =action.payload.material;
      });
  },
});

export const {} = learningModuleSlice.actions;

export const selectLearningModule = (state: RootState) => {
  return state.LearingModule.learningmodule;
};

export default learningModuleSlice.reducer;
